var map = {
	"./university_1.jpg": "0d99",
	"./university_2.jpg": "35165",
	"./university_3.jpg": "fd89",
	"./university_4.jpg": "9dda",
	"./university_5.jpg": "400c",
	"./university_6.jpg": "f416",
	"./university_7.jpg": "a9a8",
	"./university_8.jpg": "1059",
	"./university_9.jpg": "e2e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "020d";